import { LABEL_DECIMALS, MIN_RATIO } from './constants';
/**
 * @hidden
 */

export var truncateNumber = function truncateNumber(value) {
  var numberParts = value.toString().split('.');
  return numberParts.length === 1 ? "" + numberParts[0] : numberParts[0] + "." + numberParts[1].substr(0, LABEL_DECIMALS);
};
/**
 * @hidden
 */

export var calculatePercentage = function calculatePercentage(min, max, value) {
  var onePercent = Math.abs((max - min) / 100);
  return Math.abs((value - min) / onePercent);
};
/**
 * @hidden
 */

export var updateProgress = function updateProgress(progressRef, progressWrapRef, percentage, isVertical) {
  var progressPercentage = Math.max(percentage, 0.01);
  var progressWrapPercentage = 100 / progressPercentage * 100;
  progressRef.current.style.width = !isVertical ? progressPercentage + "%" : '100%';
  progressWrapRef.current.style.width = !isVertical ? progressWrapPercentage + "%" : '100%';
  progressRef.current.style.height = isVertical ? progressPercentage + "%" : '100%';
  progressWrapRef.current.style.height = isVertical ? progressWrapPercentage + "%" : '100%';
};
/**
 * @hidden
 */

export var calculateRatio = function calculateRatio(min, max, value) {
  return Math.max((value - min) / (max - min), MIN_RATIO);
};